// CFG-IA.B1 (#1541) — /settings/byoi shim redirect.
//
// ONB.C3 (A.5) deleted the old GCP-manual BYOIWizardPage. B1 relocates the
// storage surface into the CFG-IA cluster at /settings/storage. This shim
// preserves existing /settings/byoi links (sidebar deep-links, bookmarks) and
// routes them to the new storage page — no 404s for existing users.

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function SettingsBYOIRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/settings/storage', { replace: true });
  }, [navigate]);

  return (
    <div
      data-testid="settings-byoi-redirect"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontFamily: 'var(--font-body)', fontSize: 14, color: 'var(--text-secondary)', background: 'var(--bg)',
      }}
    >
      Redirecting…
    </div>
  );
}
